module.exports = __webpack_public_path__ + "h5/img/kefu.cacb21e5.png";